
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  rootGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  gridList: {
    flexWrap: 'nowrap',
    overflow: 'auto',
  },
  header: {
    alignItems: 'center',
    minHeight: 50,
    width: '100%',
    paddingLeft: '10px',
    backgroundColor: 'white',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  rootChips: {
    flexGrow: 1,
    margin: '10px',
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: 'inherit',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'
  },
  tableActionButtonIcon: {
    width: '20px',
    height: '20px'
  },
  justify: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'center',
    alignItems: 'center',
    padding: '5px',
    '& > button': {
      background: 'red',
      color: 'white'
    },
  },
  colorButton: {
    background: 'red'
  },
  headerCard: {
    top: '0',
    button: '0',
    margin: '0',
  },
  noFoundVideo: {
    display: 'flex',
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  root: {
    marginTop: '8px',
    width: '100%',
    borderRadius: '9px',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: '85vh',
  },
  appBar: {
    borderRadius: '9px',
    backgroundColor: '#1b1b1b',
    color: '#fff',
  },
  appBarRoot: {
    marginTop: '12px',
    flexGrow: 1,
    width: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    width: '25ch',
  },
  detailsInput: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  h3: {
    paddingLeft: '2px'
  },
  cardBodyList: {
    minWidth: '300px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '20px',
  },
  containerImage: {
    position: 'relative',
    width: '100%',
  },
  colorLink: {
    display: 'inline',
    // color: 'blue',
    '&:hover': {
      color: '#FF9800',
    }
  },
  gridContainer: {
    position: 'absolute',
    left: '0px',
    top: '30px',
    padding:'0px 0px 0px 70px'
  },
  gridItemsContainer: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.875rem',
    lineHeight: '1.43'
  }
}));
